var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3.17157L15 6.17157M10 17.1716H18M2 13.1716L1 17.1716L5 16.1716L16.586 4.58557C16.9609 4.21052 17.1716 3.7019 17.1716 3.17157C17.1716 2.64124 16.9609 2.13263 16.586 1.75757L16.414 1.58557C16.0389 1.21063 15.5303 1 15 1C14.4697 1 13.9611 1.21063 13.586 1.58557L2 13.1716Z",
    stroke: "#B8B8B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.09834d89c43096cebf1504cd6b06123b.svg";
export { ForwardRef as ReactComponent };